export const MEETING_HOSTS = {
  development: 'hkmeeting.net',
  test: 'hkmeeting.org',
  production: 'hkmeeting.ai',
} as const;

export const OFFICE_API_ORIGINS = {
  development: 'https://office-api-dev.hkmeeting.net',
  test: 'https://office-api-test.hkmeeting.org',
  production: 'https://office-api.hkmeeting.ai',
} as const;

export const getOfficeApiOrigin = (environment = 'development'): string =>
  Object.prototype.hasOwnProperty.call(OFFICE_API_ORIGINS, environment) ? OFFICE_API_ORIGINS[environment as keyof typeof OFFICE_API_ORIGINS] : OFFICE_API_ORIGINS.development;
